<template>
  <div class="conten-desc">
    <template v-for="(item, index) in questionList" :key="index">
      <div class="df vertical describe">
        <div>
          <div class="df desc-space">
            <div class="subtitle">问题{{ index + 1 }}</div>
            <a-textarea
              v-model:value="item.desc"
              @change="changeRecords($event, item)"
              :style="{
                width: isMobile ? '5rem' : '200px',
              }"
              :disabled="props.disabled"
              auto-size
            ></a-textarea>
          </div>

          <div class="df desc-space">
            <div class="subtitle">图片</div>
            <upload-img-vue
              ref="imgRefList"
              :attachment="item.picture"
              :disabled="props.disabled"
              :requestFn="uploadInspectionAttachment"
            ></upload-img-vue>
          </div>

          <div class="df">
            <div class="subtitle">视频</div>
            <upload-video-vue
              ref="videoRefList"
              :attachment="item.video"
              :disabled="props.disabled"
              :requestFn="uploadInspectionAttachment"
            ></upload-video-vue>
          </div>
        </div>

        <div>
          <MinusCircleOutlined
            v-if="!props.disabled"
            class="dynamic-delete-button"
            :disabled="questionList.length === 1"
            @click="removequestionList(index)"
          />
        </div>
      </div>
    </template>

    <a-button
      type="primary"
      @click="addAnalyse"
      class="space"
      :disabled="props.disabled"
    >
      新增备注
    </a-button>
  </div>
</template>

<script>
import { computed, defineComponent, nextTick, reactive, ref, watch } from "vue";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons-vue";
import {
  Toast,
  uploadMedia,
  showUploading,
  hideUploading,
} from "@/utils/index";
import { saveOrUpdateContentDesc } from "@/request/view/repair";
import { useStore } from "vuex";
import { uploadInspectionAttachment } from "@/request/view/qualityInspection";
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";

export default defineComponent({
  components: {
    PlusOutlined,
    uploadImgVue,
    uploadVideoVue,
    MinusCircleOutlined,
  },
  props: {
    formdata: Object,
    disabled: Boolean,
    question: Array,
    title: String,
    type: String,
  },
  setup(props, context) {
    const store = useStore();

    const isMobile = computed(() => store.state.isMonile);

    const questionList = reactive([]);

    const imgRefList = ref();

    const videoRefList = ref();

    const uploadFile = () => {
      return new Promise((resolve, reject) => {
        if (
          imgRefList.value === undefined ||
          videoRefList.value === undefined
        ) {
          resolve(questionList);
          return;
        }

        let promiseArr = [];
        for (let i = 0; i < imgRefList.value.length; i += 1) {
          const imgRef = imgRefList.value[i];
          const videoRef = videoRefList.value[i];
          let p = uploadMedia(imgRef, videoRef);
          promiseArr.push(p);
        }

        Promise.all(promiseArr)
          .then((res) => {
            for (let index = 0; index < res.length; index += 1) {
              const element = res[index];
              questionList[index].picture = JSON.stringify(element[0]);
              questionList[index].video = JSON.stringify(element[1]);
            }
            resolve(questionList);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const addAnalyse = () => {
      questionList.push({
        picture: null,
        desc: null,
        video: null,
      });
    };

    const removequestionList = (index) => {
      questionList.splice(index, 1);
    };

    const changeRecords = (e, item) => {
      // item.desc = e.data;
    };

    watch(
      () => props.question,
      (val) => {
        questionList.length = 0;
        if (val && val !== "null") {
          const list = JSON.parse(val);
          questionList.push(...list);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.formdata,
      (val) => {
        // console.log(val, "form data 传入的是什么");
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      store,
      uploadFile,
      addAnalyse,
      imgRefList,
      videoRefList,
      questionList,
      removequestionList,
      changeRecords,
      isMobile,
      uploadInspectionAttachment,
    };
  },
});
</script>

<style lang="less" scoped>
.conten-desc {
  margin-bottom: 20px;
  .subtitle {
    font-size: 16px;
    width: 46px;
    text-align: right;
    margin-right: 10px;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .describe {
    background: #f1f1f1;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    box-shadow: 0 0 6px 0 #f1f1f1;
  }
  .desc-space {
    margin-bottom: 16px;
  }
  .dynamic-delete-button {
    margin-left: 20px;
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
